"use strict";

angular.module("vendor")
.controller("InvoiceDetailsController", function() {});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/invoice/invoice-detail.controller.js
// module id = 1018
// module chunks = 0